import { UIText } from './UIText';
import { Palette } from '../../../res/colors';
import React from 'react';
import { Variant } from '@mui/material/styles/createTypography';

export const UISectionTitle = ({ title, variant, my }: { title: string, variant?: Variant, my?: number }) => {
    return <UIText text={title} sx={{ color: Palette.defaultPrimaryColor, my: my ?? 1 }} variant={variant || 'h5'} />;

};
